import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fa from './locales/fa.json';
import en from './locales/en.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';

const resources = {
  fa: { translation: fa },
  en: { translation: en },
  ru: { translation: ru },
  zh: { translation: zh },
};

i18n
  // The detector was a dependency but was never wired up, so nothing ever
  // wrote `i18nextLng`. Two consequences, both of them visible: the language
  // button in the header did not survive a reload, and the IP-based guess from
  // `/api/system/locale` was re-applied on every visit - overriding the
  // visitor's own choice every time.
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fa',
    supportedLngs: ['fa', 'en', 'ru', 'zh'],
    // 'en-US' and 'en-GB' are both 'en' here; there is one English translation.
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,

    detection: {
      // The visitor's own choice first, then the browser's setting. The
      // server's IP guess is applied separately, and only when neither of
      // these has an answer.
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React escapes already
    },

    returnEmptyString: false,
  });

export default i18n;
